import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "studentField",
    "studentSelect",
    "groupField",
    "groupSelect",
    "assignmentTypeField",
    "draftButton",
  ];
  static values = { defaultAssignmentType: String };

  connect() {
    this.multiStudentMode = false;
    this.resetAssignmentType();
  }

  handleStudentChange(e) {
    const studentCount = this.studentSelectTarget.tomselect.items.length;

    if (studentCount > 0) {
      this.draftButtonTarget.classList.add("d-none");
      this.groupFieldTarget.classList.add("d-none");
      this.groupSelectTarget.tomselect.clear();
    } else {
      this.draftButtonTarget.classList.remove("d-none");
      this.groupFieldTarget.classList.remove("d-none");
    }

    if (studentCount > 1) {
      this.enableMultiStudent();
    } else {
      this.disableMultiStudent();
    }
  }

  handleGroupChange(e) {
    const hasGroupSelected = this.groupSelectTarget.tomselect.items.length > 0;

    if (hasGroupSelected) {
      this.enableMultiStudent();
      this.draftButtonTarget.classList.add("d-none");
      this.studentFieldTarget.classList.add("d-none");
      this.studentSelectTarget.tomselect.clear();
    } else {
      this.disableMultiStudent();
      this.draftButtonTarget.classList.remove("d-none");
      this.studentFieldTarget.classList.remove("d-none");
    }
  }

  enableMultiStudent() {
    if (this.multiStudentMode) {
      return;
    }
    this.assignmentTypeFieldTarget.classList.remove("d-none");
    this.multiStudentMode = true;
  }

  disableMultiStudent() {
    if (!this.multiStudentMode) {
      return;
    }
    this.resetAssignmentType();
    this.assignmentTypeFieldTarget.classList.add("d-none");
    this.multiStudentMode = false;
  }

  resetAssignmentType() {
    const defaultInput = this.assignmentTypeFieldTarget.querySelector(
      `[value=${this.defaultAssignmentTypeValue}]`,
    );

    defaultInput.checked = true;
  }
}
